import { Injectable } from '@angular/core';

import { apiName } from "./data.service";
import { Cidade } from "./cidade.model";
import { RestService } from "../../../../core/services/rest.service";

@Injectable()
export class CidadeApiService {

    constructor(
        private _restService: RestService
    ) { }

    onPost(object: Cidade, done: any) {
        this._restService.onPost(apiName, object, done);
    }

    onPut(object: Cidade, done: any) {
        this._restService.onPut(apiName, object, done);
    }

    onDelete(objectId: number, done: any) {
        this._restService.onDelete(apiName, objectId, done);
    }

    onGetByEstado(estadoId: number, done: any) {
        var filter: any = {where: {estadoId: estadoId}, include: ["estado"]};
        this._restService.onGetPost(apiName, filter, done);
    }

    onGetById(objectId: number, done: any) {
        var filter: any = {include: ["estado"]};
        this._restService.onGetPostId(apiName, objectId, filter, done);
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/enderecos/cidades/shared/cidade-api.service.ts
 **/